/** @jsxImportSource @emotion/react */
import bannerDesktop from "@/assets/img/banner-5-desktop.png";
import bannerMobile from "@/assets/img/banner-5-mobile.png";
import { Col, Row } from "antd";
import type { ReactNode } from "react";
import { style } from "./style";

type Props = {
  children: ReactNode;
};

export const WelcomeContainer = ({ children }: Props) => {
  return (
    <Row css={style}>
      <Col xs={24} lg={0}>
        <img src={bannerMobile} alt="bannerMobile" width="640" height="235" />
      </Col>
      <Col xs={0} lg={7}>
        <img src={bannerDesktop} alt="bannerDesktop" width="962" height="553" />
      </Col>

      <Col xs={24} lg={17}>
        {children}
      </Col>
    </Row>
  );
};
